<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <template v-if="btnShow == 1">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="图片" prop="src">
          <image-upload v-model="faceImg" :isShowTip="true" :limit="9" />
        </el-form-item>
      </template>
      <template v-if="btnShow == 2">
        <el-form-item label="用户" prop="userInfoName">
          <el-input v-model="userInfoName" placeholder="请输入用户" disabled />
        </el-form-item>
      </template>
      <template v-if="btnShow == 3">
        <el-form-item label="操作方式" prop="actionType">
          <el-radio-group v-model="actionType">
            <el-radio :label="'APPEND'">追加 </el-radio>
            <el-radio :label="'REPLACE'">替换</el-radio>
          </el-radio-group>
          <span style="display: block; color: red; font-size: 12px"
            >追加：新增的人脸照片和历史照片同步保存 ;<br />替换：新增的人脸照片会替换历史所有照片</span
          >
        </el-form-item>
        <el-form-item label="图片" prop="src">
          <image-upload v-model="faceImg" :isShowTip="true" :limit="9" />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  faceLibraryaddUser,
  faceLibraryupd,
  faceLibraryaddFace,
} from "@/api/faceDatabase";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {
        platForm: null,
        userId: null,
        userInfo: null,
        createUser: null,
      },
      faceImg: [],
      // 表单校验
      rules: {},
      btnShow: 1,
      userInfoName: null,
      actionType: "APPEND",
    };
  },
  methods: {
    addCreateForm(oriApi, userName, platForm) {
      this.reset();
      this.open = true;
      this.form.createUser = userName?userName:'userName';
      this.form.platForm = platForm;
      //   this.form.oriApi = oriApi
      this.title = "添加用户";
      this.btnShow = 1;
    },
    showCreateForm(record) {
      this.reset();
      this.open = true;
      this.form = record;
      this.title = "修改用户";
      this.btnShow = 2;
    },
    addFaceForm(record) {
      this.reset();
      this.open = true;
      this.form = record;
      this.title = "添加人脸";
      this.actionType = "APPEND";
      this.btnShow = 3;
    },
    // 表单重置
    reset() {
      this.form = {
        platForm: null,
        userId: null,
        userInfo: null,
      };
      this.faceImg = [];
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.faceImg.length > 0) {
            this.form.urlList = this.faceImg.split(",");
          }
          const obj = {
            id:this.form.userId,
            name:this.form.name
          };
          this.form.userInfo = JSON.stringify(obj);
          // else{
          //     this.$modal.msgError("请上传图片")
          //     return
          // }
          if (this.form.id != null) {
            if (this.btnShow == 2) {
              updateOrderDeviceReplace(this.form).then((response) => {
                this.$modal.msgSuccess("修改成功");
                this.open = false;
                this.$emit("ok");
              });
            } else if (this.btnShow == 3) {
              const data = {
                id: this.form.id,
                actionType: this.actionType,
                urlList: this.form.urlList,
              };
              faceLibraryaddFace(data).then((response) => {
                this.$modal.msgSuccess("新增人脸成功");
                this.open = false;
                this.$emit("ok");
              });
            }
          } else {
            faceLibraryaddUser(this.form).then((response) => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.$emit("ok");
            });
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.$emit("ok");
    },
  },
  mounted() {},
};
</script>

<style></style>
